import React, { Component, Fragment } from 'react';

import { assetStatus } from 'components/shared/MaintenanceStatuses';
import AssetTableStatusMenu from 'components/shared/AssetTableStatusMenu';

import { List, AutoSizer } from 'react-virtualized';

import { AccentColor } from 'helpers/AccentColorHelper';
import { groupedTableData, buttonStyle } from 'helpers/tableHelpers';

import Button from '@material-ui/core/Button';

import { MuiThemeProvider } from '@material-ui/core';
import { createMuiTheme } from '@material-ui/core';

const DEFAULT_ROW_HEIGHT = 140;

class MaintenanceAssetsMobile extends Component {
  constructor(props) {
    super(props);
    this.state = {
      anchorEl: null,
      rowData: {},
    };
  }

  handleClick = (event, rowData) => {
    this.setState({ anchorEl: event.currentTarget, rowData: rowData });
  };

  handleClose = () => {
    this.setState({ anchorEl: null, rowData: {} });
  };

  changeAssetStatus = statusName => {
    let assetData = this.state.rowData;
    assetData['status'] = statusName;

    this.props.updateAsset(assetData, assetData.id).then(() => {
      this.props.getMaintenanceAssets();
      this.handleClose();
    });
  };

  rowHeight = (index, tableData) => {
    return tableData[index].tableHeader ? 35 : DEFAULT_ROW_HEIGHT;
  };

  render() {
    const tableData = groupedTableData(this.props.data);

    return (
      <Fragment>
        <AssetTableStatusMenu
          anchorEl={this.state.anchorEl}
          handleClose={this.handleClose}
          changeStatus={this.changeAssetStatus}
          currentStatus={this.state.rowData.status}
        />
        <div className="mobile_card" style={{ height: 'calc(100% - 43px)', margin: '0 -15px' }}>
          {tableData.length === 0 && (
            <div id="mobile_card">
              <div className="row">
                <p
                  style={{
                    textAlign: 'center',
                    color: 'rgba(0,0,0,0.5)',
                    marginTop: '13px',
                  }}
                >
                  {' '}
                  You don&rsquo;t have any assets{' '}
                </p>
              </div>
            </div>
          )}
          <AutoSizer>
            {({ height, width }) => (
              <List
                rowCount={tableData.length}
                rowHeight={({ index }) => this.rowHeight(index, tableData)}
                rowRenderer={({ key, index, style }) =>
                  this.rowRenderer({ key, index, style }, tableData)}
                width={width}
                height={height}
              />
            )}
          </AutoSizer>
        </div>
      </Fragment>
    );
  }

  rowRenderer = ({ key, index, style }, data) => {
    const assets = data;
    let rowStyle = Object.assign({ padding: '5px 10px' }, style);

    return (
      <Fragment>
        {this.renderTableHeader(key, assets[index], rowStyle)}
        {this.renderTableContents(key, assets[index], rowStyle)}
      </Fragment>
    );
  };

  renderTableHeader = (key, rowValue, rowStyle) => {
    if (!rowValue.tableHeader) return;

    return (
      <div key={key} style={rowStyle}>
        {' '}
        <h5
          style={{
            margin: '5px 0 0',
            fontSize: '15px',
            fontFamily: 'Circular-Black',
            color: AccentColor(),
          }}
        >
          {rowValue.tableHeader}
        </h5>{' '}
      </div>
    );
  };

  renderTableContents = (key, rowValue, rowStyle) => {
    if (rowValue.tableHeader) return;

    return (
      <div key={key} style={rowStyle}>
        <div className="row">
          <div className="mobile_header">
            {' '}
            <b style={{ fontFamily: 'Circular-Bold' }}>
              {rowValue.unit_number} {rowValue.property_name}
            </b>
          </div>
          <div style={{ float: 'right', marginTop: '4px' }}>
            <span style={{ fontSize: '11px', color: 'grey' }}>{rowValue.location}</span>
            {this.renderStatusButton(rowValue)}
          </div>
        </div>
        <div className="row">
          <div className="mobile_subheader">{rowValue.name}</div>
        </div>
        <div className="row">
          <div className="mobile_subheader">{rowValue.category}</div>
        </div>
        <div className="row">
          <div className="mobile_subheader">{rowValue.make}</div>
        </div>
        <div className="row">
          <div className="mobile_subheader">{rowValue.model}</div>
        </div>
        <div className="row">
          <div className="mobile_subheader">
            <button
              type="button"
              className="link-button"
              onClick={() => this.props.goToTicket(rowValue.id)}
              style={{ cursor: 'pointer' }}
            >
              view details
            </button>
          </div>
        </div>
      </div>
    );
  };

  renderStatusButton = rowValue => (
    <MuiThemeProvider theme={createMuiTheme(buttonStyle)}>
      <Button
        aria-owns={this.state.anchorEl ? 'simple-menu' : null}
        aria-haspopup="true"
        onClick={event => this.handleClick(event, rowValue)}
        style={{
          padding: 0,
          height: '20px !important',
          minWidth: '20px !important',
          verticalAlign: 'bottom',
        }}
      >
        <span>{assetStatus(rowValue.status)}</span>
      </Button>
    </MuiThemeProvider>
  );
}

export default MaintenanceAssetsMobile;
